<template>
  <div id="dvreg" @click="HideDropdown" class="page-effect">
    <div class="success-wrapper-hld">
      <!-- Payment  is successful.Please check your Inbox for more details. -->
      <div
        class="modal fade payment-sucess-popup show"
        role="dialog"
        style="display: block; padding-right: 16px"
      >
        <div class="modal-dialog succcess-dialog">
          <!-- Modal content-->
          <div class="modal-content py-3">
            <div class="modal-header pb-0 text-center d-block">
              <img src="../assets/Images/icons/icon-success.png" class="mb-4" />
              <h4 class="">Payment Successful</h4>
              <p>Please check your Inbox for more details.</p>
            </div>
            <div class="modal-body">
              <div class="btn-section text-center btn-theme">
                <router-link
                  :to="getRegUrl"
                  class="
                    btn
                    text-uppercase
                    space-button
                    border-tranprent
                    mb-1
                    mr-md-2
                  "
                  >Register New
                </router-link>
                <!-- <router-link to="/" class="btn text-uppercase space-button mb-1"
                  >Proceed to Login
                </router-link> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop fade show"></div>
    </div>
  </div>
</template>
<script>
//import Vue from "vue";
import jQuery from "jquery";
let $ = jQuery;

// var self;
export default {
  data() {
    return {
      //   regUrl: "",
      //  evntId: "",
    };
  },
  mounted() {
    $("#topmenu").hide();
    $("#leftmenu").hide();
  },
  computed: {
    getRegUrl() {
      if (this.$route.params.e) {
        return "/eventv3/" + this.$route.params.e;
      } else {
        return "/events/";
      }
    },
  },
};
</script>